import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.typed.int8-array";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid, Deferred, PromiseHelper, Stream } from "../../common/Exports";
import { Contracts } from "../Contracts";
import { AudioOutputFormatImpl } from "./AudioOutputFormat";
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */

export var AudioOutputStream = /*#__PURE__*/function () {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  function AudioOutputStream() {
    _classCallCheck(this, AudioOutputStream);
  }
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioOutputStream.createPullStream
   * @function
   * @public
   * @returns {PullAudioOutputStream} The audio output stream being created.
   */


  _createClass(AudioOutputStream, null, [{
    key: "createPullStream",
    value: function createPullStream() {
      return PullAudioOutputStream.create();
    }
  }]);

  return AudioOutputStream;
}();
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioOutputStream = /*#__PURE__*/function (_AudioOutputStream) {
  _inherits(PullAudioOutputStream, _AudioOutputStream);

  var _super = _createSuper(PullAudioOutputStream);

  function PullAudioOutputStream() {
    _classCallCheck(this, PullAudioOutputStream);

    return _super.apply(this, arguments);
  }

  _createClass(PullAudioOutputStream, null, [{
    key: "create",

    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */
    value: function create() {
      return new PullAudioOutputStreamImpl();
    }
  }]);

  return PullAudioOutputStream;
}(AudioOutputStream);
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var PullAudioOutputStreamImpl = /*#__PURE__*/function (_PullAudioOutputStrea) {
  _inherits(PullAudioOutputStreamImpl, _PullAudioOutputStrea);

  var _super2 = _createSuper(PullAudioOutputStreamImpl);

  /**
   * Creates and initializes an instance with the given values.
   * @constructor
   */
  function PullAudioOutputStreamImpl() {
    var _this;

    _classCallCheck(this, PullAudioOutputStreamImpl);

    _this = _super2.call(this);
    _this.privId = createNoDashGuid();
    _this.privStream = new Stream();
    _this.streamReader = _this.privStream.getReader();
    return _this;
  }
  /**
   * Sets the format information to the stream. For internal use only.
   * @param {AudioStreamFormat} format - the format to be set.
   */


  _createClass(PullAudioOutputStreamImpl, [{
    key: "id",

    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */
    value: function id() {
      return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */

  }, {
    key: "read",
    value: function read(dataBuffer) {
      var _this2 = this;

      var intView = new Int8Array(dataBuffer);
      var totalBytes = 0;

      if (this.privLastChunkView !== undefined) {
        if (this.privLastChunkView.length > dataBuffer.byteLength) {
          intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
          this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
          return PromiseHelper.fromResult(dataBuffer.byteLength);
        }

        intView.set(this.privLastChunkView);
        totalBytes = this.privLastChunkView.length;
        this.privLastChunkView = undefined;
      }

      var deffer = new Deferred(); // Until we have the minimum number of bytes to send in a transmission, keep asking for more.

      var readUntilFilled = function readUntilFilled() {
        if (totalBytes < dataBuffer.byteLength && !_this2.streamReader.isClosed) {
          _this2.streamReader.read().onSuccessContinueWith(function (chunk) {
            if (chunk !== undefined && !chunk.isEnd) {
              var tmpBuffer;

              if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                _this2.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
              } else {
                tmpBuffer = chunk.buffer;
              }

              intView.set(new Int8Array(tmpBuffer), totalBytes);
              totalBytes += tmpBuffer.byteLength;
              readUntilFilled();
            } else {
              _this2.streamReader.close();

              deffer.resolve(totalBytes);
            }
          });
        } else {
          deffer.resolve(totalBytes);
        }
      };

      readUntilFilled();
      return deffer.promise();
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */

  }, {
    key: "write",
    value: function write(dataBuffer) {
      Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
      this.privStream.writeStreamChunk({
        buffer: dataBuffer,
        isEnd: false,
        timeReceived: Date.now()
      });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      this.privStream.close();
    }
  }, {
    key: "format",
    set: function set(format) {
      if (format === undefined || format === null) {
        this.privFormat = AudioOutputFormatImpl.getDefaultOutputFormat();
      }

      this.privFormat = format;
    }
    /**
     * Format information for the audio
     */
    ,
    get: function get() {
      return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */

  }, {
    key: "isClosed",
    get: function get() {
      return this.privStream.isClosed;
    }
  }]);

  return PullAudioOutputStreamImpl;
}(PullAudioOutputStream);
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */
// tslint:disable-next-line:max-classes-per-file

export var PushAudioOutputStream = /*#__PURE__*/function (_AudioOutputStream2) {
  _inherits(PushAudioOutputStream, _AudioOutputStream2);

  var _super3 = _createSuper(PushAudioOutputStream);

  /**
   * Creates and initializes and instance.
   * @constructor
   */
  function PushAudioOutputStream() {
    _classCallCheck(this, PushAudioOutputStream);

    return _super3.call(this);
  }
  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * write() and close() methods.
   * @member PushAudioOutputStream.create
   * @function
   * @public
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   *        derived from PushAudioOutputStreamCallback
   * @returns {PushAudioOutputStream} The push audio output stream being created.
   */


  _createClass(PushAudioOutputStream, null, [{
    key: "create",
    value: function create(callback) {
      return new PushAudioOutputStreamImpl(callback);
    }
  }]);

  return PushAudioOutputStream;
}(AudioOutputStream);
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var PushAudioOutputStreamImpl = /*#__PURE__*/function (_PushAudioOutputStrea) {
  _inherits(PushAudioOutputStreamImpl, _PushAudioOutputStrea);

  var _super4 = _createSuper(PushAudioOutputStreamImpl);

  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * read() and close() methods.
   * @constructor
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   *        derived from PushAudioOutputStreamCallback
   */
  function PushAudioOutputStreamImpl(callback) {
    var _this3;

    _classCallCheck(this, PushAudioOutputStreamImpl);

    _this3 = _super4.call(this);
    _this3.privId = createNoDashGuid();
    _this3.privCallback = callback;
    return _this3;
  } // tslint:disable-next-line:no-empty


  _createClass(PushAudioOutputStreamImpl, [{
    key: "write",
    value: function write(buffer) {
      if (!!this.privCallback.write) {
        this.privCallback.write(buffer);
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (!!this.privCallback.close) {
        this.privCallback.close();
      }
    }
  }, {
    key: "id",
    value: function id() {
      return this.privId;
    }
  }, {
    key: "format",
    set: function set(format) {}
  }]);

  return PushAudioOutputStreamImpl;
}(PushAudioOutputStream);